<template>
  <MoleculeReturnTo/>
</template>

<script>
export default {
  name: 'OrganismReturnTo',

  components: {
    MoleculeReturnTo: () => import('@/components/molecules/MoleculeReturnTo')
  }
}
</script>
